import React from "react";
import { Spin } from "antd";
import { Navigate, useLocation } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

// Gates the main app: shows a spinner while the session is hydrating, then
// redirects to /login if there is no authenticated user.
const RequireAuth = ({ children }) => {
  const { user, loadingAuth } = useAppContext();
  const location = useLocation();

  if (loadingAuth) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth;
